import * as z from "zod/v4";

export const getConversationTopics = {
  name: "getConversationTopics" as const,
  input: z.object({}),
  output: z.object({ topics: z.array(z.string()) }),
};
